import classNames from 'classnames';
import mixpanel from 'mixpanel-browser';
import moment from 'moment';
import { array, arrayOf, bool, func, object, oneOf, shape, string } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { compose } from 'redux';

import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { chatGptQuestionsQuery, createDealApi, updateTransaction } from '../../util/api.js';
import { convertMoneyToNumber } from '../../util/currency';
import {
  downloadAsPDFChatgpt,
  ensureListing,
  ensureOwnListing,
  ensureTransaction,
  ensureUser,
  getPageURL,
  uploadPDFToCloudinary,
  userDisplayNameAsString,
} from '../../util/data';
import { FormattedMessage, intlShape, useIntl } from '../../util/reactIntl';
import { createResourceLocatorString } from '../../util/routes.js';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  LISTING_STATE_CLOSED,
  LISTING_STATE_DRAFT,
  LISTING_STATE_PENDING_APPROVAL,
  LISTING_STATE_PUBLISHED,
  propTypes,
} from '../../util/types';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PARAM_TYPE_DRAFT,
  LISTING_PAGE_PARAM_TYPE_EDIT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
  createSlug,
} from '../../util/urlHelpers';
// import { richText } from '../../util/richText';

import {
  Button,
  IconCard,
  IconShare,
  LayoutSingleColumn,
  Modal,
  NamedLink,
  NamedRedirect,
  Page,
  PrimaryButton,
  ResponsiveImage,
  SocialShare,
} from '../../components';

import { getProcess } from '../../transactions/transaction.js';
import FooterContainer from '../FooterContainer/FooterContainer';
import NotFoundPage from '../NotFoundPage/NotFoundPage';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import ActionBarMaybe from './ActionBarMaybe';
import ChatForm from './ChatForm/ChatForm';
import SectionCompany from './SectionCompany';
import SectionPro from './SectionPro';

import { getListingsById, getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { initializeCardPaymentData } from '../../ducks/stripe.duck.js';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/ui.duck';
import { confirmPayment, initiateOrder, sendMessage } from '../CheckoutPage/CheckoutPage.duck.js';
import { closeListing, openListing } from '../ManageListingsPage/ManageListingsPage.duck.js';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck.js';

import {
  checkPendingDeduction,
  createResumePDF,
  fetchTimeSlots,
  fetchTransactionLineItems,
  requestInsertCollection,
  sendInquiry,
  updateRole,
} from './ListingPage.duck';

import {
  ErrorPage,
  LoadingPage,
  findRoleGroup,
  handleSubmit,
  handleSubmitInquiry,
  priceData,
} from './ListingPage.shared';

import listView from '../../assets/images/listView.png';
import share from '../../assets/images/share.png';

import css from './ListingPage.module.css';
import { MINIMUM_TOKEN_DEDUCTION } from '../../util/constants.js';
import { useParams } from 'react-router-dom';
import {  onCancelSendgridSearchEmail, updateRoleQuestion } from '../EditListingPage/EditListingPage.duck.js';
import { FollowCompany, updateFollower } from '../FollowCompanyPage/FollowCompanyPage.duck.js';
import { getSessionId } from '../../analytics/analytics.js';
const { UUID } = sdkTypes;

export const ListingPageComponent = props => {
  const [showModal, setShowModal] = useState(false);
  const [modalInProgress, setModalInProgress] = useState(false);
  const [currentTab, setCurrentTab] = useState(false);
  const [copyText, setCopyText] = useState(false);
  const [firstConnectionModal, setFirstConnectionModal] = useState(false);
  const [showInterestModal, setShowInterestModal] = useState(false);
  const [insufficientTokens, setInsufficientTokens] = useState(false);
  const [tokensToDeduct, setTokensToDeduct] = useState(MINIMUM_TOKEN_DEDUCTION);
  const [ListingModal, setListingModal] = useState(false);
  const [profileModal, setProfileModal] = useState(false);
  // const [videoPlay, setVideoPlay] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setCopyText(false);
    }, 5000);
  }, [copyText]);
  // const [inquiryModalOpen, setInquiryModalOpen] = useState(
  //   props.inquiryModalOpenForListingId === props.params.id
  // );

  const {
    isAuthenticated,
    currentUser,
    currentUserListings,
    authorListings,
    getListing,
    getOwnListing,
    intl,
    onManageDisableScrolling,
    params: rawParams,
    location,
    scrollingDisabled,
    showListingError,
    reviews,
    fetchReviewsError,
    listingConfig: listingConfigProp,
    history,
    callSetInitialValues,
    onInitializeCardPaymentData,
    config,
    routeConfiguration,
    createResumeInProgress,
    onCreateResumePDF,
    onInsertCollection,
    onUpdateProfile,
    onInitiateOrder,
    onConfirmPayment,
    onSendMessage,
    showPortfolio,
    portfolioId,
    onCloseListing,
    onOpenListing,
    onCheckPendingDeduction,
    sendInquiryInProgress,
    sendInquiryError,
    onSendInquiry,
    updateRoleQuestion,
    onFollowCompany,
    onUpdateFollower,
    followCompany,
    followCompanyInProgress,
    parentJobRolesInProgress,
    parentJobRoles: roleListingFromMongo,
    onCancelSendgridSearchEmail,
    savedNotes
    // lineItems,
    // onSendInquiry,
    // fetchLineItemsInProgress,
    // fetchLineItemsError,
    // onFetchTransactionLineItems,
    // sendInquiryInProgress,
    // sendInquiryError,
    // monthlyTimeSlots,
    // onFetchTimeSlots,
  } = props;
  const paramsFromUrl = useParams();
  const roleFromInquiry = paramsFromUrl ? paramsFromUrl?.role : null;
  useEffect(() => {
    if (roleFromInquiry && roleFromInquiry.length) {
      setShowModal(true)
    }
  }, roleFromInquiry)

  // prop override makes testing a bit easier
  // TODO: improve this when updating test setup
  const listingConfig = listingConfigProp || config.listing;
  const listingId = new UUID(rawParams.id);
  const isPendingApprovalVariant = rawParams.variant === LISTING_PAGE_PENDING_APPROVAL_VARIANT;
  const isDraftVariant = rawParams.variant === LISTING_PAGE_DRAFT_VARIANT;
  const publishedListing = currentUserListings && currentUserListings.length
    ? currentUserListings.filter(c => c.attributes.state == LISTING_STATE_PUBLISHED)
    : [];
    const userListingId = currentUserListings && currentUserListings.length && currentUserListings[0].id;
  const currentListing =
    isPendingApprovalVariant || isDraftVariant
      ? ensureOwnListing(getOwnListing(listingId))
      : ensureListing(getListing(listingId));
      const currentAuthorList = (currentListing && currentListing.id && currentListing.author) || {};

  const { bio, publicData: aPublicData } = (currentAuthorList && currentAuthorList?.id && currentAuthorList?.attributes?.profile) || {};
  const {
    isAdminAccount
  } = aPublicData || {};

  const company = (currentListing && currentListing?.attributes?.publicData?.listingType === "company") || '';
  useEffect(() => {
    if (company) {
      setListingModal(true)
    }
  }, [company])

  const listingSlug = rawParams.slug || createSlug(currentListing.attributes.title || '');
  const params = { slug: listingSlug, ...rawParams };

  const listingPathParamType = isDraftVariant
    ? LISTING_PAGE_PARAM_TYPE_DRAFT
    : LISTING_PAGE_PARAM_TYPE_EDIT;

  const topbar = <TopbarContainer />;
  const {
    description = '',
    price = null,
    title = '',
    publicData = {},
  } = (currentListing.id && currentListing.attributes) || {};

  const {
    educations = [],
    experiences = [],
    portfolio = [],
    skills = [],
    q_as,
    addSelfie1,
    addSelfie2,
    uploadVideoInPhotoes,
    ADMIN,
  } = publicData;
  const [visible, setVisible] = useState(false);
  const [downloadLoader, setDownloadLoader] = useState(false)

  const filterTabs = [];
  if (publicData) {
    if (description && description.length > 0) {
      filterTabs.push("Bio");
    }
    if (skills && skills.length) {
      filterTabs.push("Skills");
    }
    if (reviews && reviews.length) {
      filterTabs.push("Reviews");
    }
    if (portfolio && portfolio.length && isAuthenticated && showPortfolio) {
      filterTabs.push("Portfolio");
    }
    if (experiences && experiences.length && isAuthenticated && showPortfolio) {
      filterTabs.push("History");
    }
    if (q_as && q_as.length) {
      filterTabs.push("Q&A");
    }
    if (addSelfie1 && addSelfie2) {
      filterTabs.push("Personal");
    }
    if (educations && educations.length && isAuthenticated && showPortfolio) {
      filterTabs.push("Education");
    }
  }

  const { protectedData: uProtectedData, publicData: uPublicData } = (currentUser && currentUser.id && currentUser.attributes.profile) || {};
  const { currentSeeds = 0, CurrentTokens = 0, firstConnectionRequest = false, firstConnectionOnAfterDisable = false } = uProtectedData || {};
  const CurrentSeeds = currentSeeds || CurrentTokens;
  const { accountType: cAccountType } = uPublicData || {};
  const { workType: modalWorkType, address: modelAddress, timezone: modalTimezone, roles: modalRoles, responsibilities: modalResponsibilities } = currentListing?.attributes?.publicData || {};

  const showInterestedButton = (currentUserListings && currentUserListings?.[0]?.attributes && currentUserListings?.[0]?.attributes.state && currentUserListings?.[0]?.attributes?.state == LISTING_STATE_PUBLISHED) || false;

  const handleClick = (modalId, userListingId) => {
    if (!showInterestedButton) {
      setProfileModal(true)
      return;
    };

    const fractionalRoles = currentUserListings?.flatMap(l =>
      l?.attributes?.publicData?.experiences?.map(r => r.label) || []
    ) || [];

    const companyRoles = modalRoles?.map(r => r.label) || [];
    const fractionalGroups = fractionalRoles?.map(findRoleGroup).filter(Boolean);
    const companyGroups = companyRoles?.map(findRoleGroup).filter(Boolean);

    const isMatch = fractionalGroups?.some(fg => companyGroups.includes(fg));
    if (!isMatch) {
      setShowInterestModal(true);
      return;
    }

    onUpdateProfile({ positionId: modalId?.uuid, publicData: { searchActivity: true } })
    onSubmitInquiry({ modalId, message: `Hey, I am interested in ${(companyRoles && companyRoles?.length && Array.isArray(companyRoles)) ? `the ${companyRoles[0]}` : 'this'} role`, userListingId })
    onCancelSendgridSearchEmail(currentUser?.id?.uuid)
  };

  useEffect(() => {
    if (cAccountType == "company" && !firstConnectionRequest && !firstConnectionModal) {
      // setFirstConnectionModal('CONNECTION');
    }
  }, [cAccountType]);

  useEffect(() => {
    let tabsOffsetPosition = [];

    if (currentTab) {
      filterTabs.forEach(tab => {
        const element = document.getElementById(tab);
        const offset = 55;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = element && element.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;
        tabsOffsetPosition.push({
          tab,
          offsetPosition
        });
      });
    }

    const scrollHandler = () => {
      if (typeof window !== 'undefined') {
        for (let i = 0; i < tabsOffsetPosition.length; i++) {
          const op = tabsOffsetPosition[i];
          if (i == 0) {
            if (parseInt(window.scrollY) < parseInt(tabsOffsetPosition[1].offsetPosition - 55)) {
              setCurrentTab(op.tab);
              break;
            }
          } else if (i == (tabsOffsetPosition.length - 1)) {
            if (parseInt(window.scrollY) > parseInt(tabsOffsetPosition[1].offsetPosition)) {
              setCurrentTab(op.tab);
              break;
            }
          } else if (parseInt(window.scrollY) >= parseInt(op.offsetPosition - 65) && parseInt(window.scrollY) <= parseInt(tabsOffsetPosition[i + 1].offsetPosition - 65)) {
            setCurrentTab(op.tab);
            break;
          }
        }

        if (window.pageYOffset > 596) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      }
    };

    if (typeof window !== 'undefined' && currentTab) {
      window.addEventListener('scroll', scrollHandler);
    }

    return () => {
      if (typeof window !== 'undefined' && currentTab) {
        window.removeEventListener('scroll', scrollHandler);
      }
    }
  }, [currentTab]);

  const authorAvailable = currentListing && currentListing.author;
  const userAndListingAuthorAvailable = !!(currentUser && authorAvailable);
  const isOwnListing =
    userAndListingAuthorAvailable && currentListing.author.id.uuid === currentUser.id.uuid;

  const currentAuthor = authorAvailable ? currentListing.author : null;
  const ensuredAuthor = ensureUser(currentAuthor);

  // When user is banned or deleted the listing is also deleted.
  // Because listing can be never showed with banned or deleted user we don't have to provide
  // banned or deleted display names for the function
  const authorDisplayName = userDisplayNameAsString(ensuredAuthor, '');
  const { availableHoursPerWeek } = ensuredAuthor?.attributes?.profile?.publicData || {};
  const { companyName, accountType } = (ensuredAuthor && ensuredAuthor.id && ensuredAuthor.attributes?.profile?.publicData) || {};
  const isCompany = accountType ? accountType == 'company' : true;
  const listingTab = isDraftVariant ? 'photos' : isCompany ? 'requirements' : 'details';

  const containerRef = React.useRef(null);

  useEffect(() => {
    if (!currentListing?.id?.uuid) return;

    // --- 1. Dwell-Time Tracking ---
    const startTime = Date.now();
    let fired30s = false;

    const trackDwell = (duration, isExit = false) => {
      mixpanel.track(
        'profile_dwell',
        {
          page_type: isCompany ? 'company_profile' : 'fractional_profile',
          target_id: currentListing.id.uuid,
          duration_seconds: duration,
        },
        isExit ? { transport: 'sendBeacon' } : {}
      );
    };

    // Set a timer for 30s threshold
    const timer30s = setTimeout(() => {
      fired30s = true;
      trackDwell(30);
    }, 30000);

    // --- 2. Copy-Event Tracking ---
    const handleCopy = e => {
      console.log('working xyzzz');
      const selectedText = window.getSelection()?.toString();
      if (selectedText && selectedText.trim().length > 0) {
        mixpanel.track('profile_content_copied', {
          page_type: isCompany ? 'company_profile' : 'fractional_profile',
          target_id: currentListing.id.uuid,
          user_id: currentUser?.id?.uuid || null,
          session_id: getSessionId(),
          selection_length: selectedText.length,
        });
      }
    };

    const container = containerRef.current;
    if (container) {
      container.addEventListener('copy', handleCopy);
    }

    // Cleanups on unmount/exit
    return () => {
      clearTimeout(timer30s);
      if (container) {
        container.removeEventListener('copy', handleCopy);
      }
      const elapsed = Math.round((Date.now() - startTime) / 1000);
      if (elapsed > 0) {
        trackDwell(elapsed, true);
      }
    };
  }, [isCompany, currentListing?.id?.uuid, currentUser?.id?.uuid]);

  if (ADMIN) {
    return <NamedRedirect name={'PurchaseAcornsPage'} />;
  } else if (showListingError && showListingError.status === 404) {
    // 404 listing not found
    return <NotFoundPage />;
  } else if (showListingError) {
    // Other error in fetching listing
    return (
      <ErrorPage
        topbar={topbar}
        scrollingDisabled={scrollingDisabled}
        intl={intl}
      />
    );
  } else if (!currentListing.id) {
    // Still loading the listing
    return (
      <LoadingPage
        topbar={topbar}
        scrollingDisabled={scrollingDisabled}
        intl={intl}
      />
    );
  }

  const richTitle = title ? <span>{title.split(' ')[0]}</span> : null;
  const isApproved =
    currentListing.id && currentListing.attributes.state !== LISTING_STATE_PENDING_APPROVAL;
  const state = currentListing.id && currentListing?.attributes?.state;
  let isClosed = state === LISTING_STATE_CLOSED;
  const pendingIsApproved = isPendingApprovalVariant && isApproved;

  // If a /pending-approval URL is shared, the UI requires
  // authentication and attempts to fetch the listing from own
  // listings. This will fail with 403 Forbidden if the author is
  // another user. We use this information to try to fetch the
  // public listing.
  const pendingOtherUsersListing =
    (isPendingApprovalVariant || isDraftVariant) &&
    showListingError &&
    showListingError.status === 403;
  const shouldShowPublicListingPage = pendingIsApproved || pendingOtherUsersListing;

  if (shouldShowPublicListingPage) {
    return <NamedRedirect name="ListingPage" params={params} search={location.search} />;
  }

  const { formattedPrice } = priceData(price, config.currency, intl);

  const commonParams = { params, history, routes: routeConfiguration };
  const onSubmit = handleSubmit({
    ...commonParams,
    currentUser,
    callSetInitialValues,
    getListing,
    onInitializeCardPaymentData,
  });

  const onSubmitInquiry = handleSubmitInquiry({
    ...commonParams,
    getListing,
    onSendInquiry,
  });

  const handleOrderSubmit = values => {
    const isCurrentlyClosed = currentListing.attributes.state === LISTING_STATE_CLOSED;
    if (isOwnListing || isCurrentlyClosed) {
      window.scrollTo(0, 0);
    } else {
      onSubmit(values);
    }
  };

  const facebookImages = (typeof uploadVideoInPhotoes == 'string' || typeof addSelfie1 == 'string' || typeof addSelfie2 == 'string')
    ? [uploadVideoInPhotoes
      ? uploadVideoInPhotoes.replace(/\.(mp4|mkv|wmv|m4v|mov|avi|flv|webm|flac|mka|m4a|aac|ogg)$/i, '.png')
      : (addSelfie1 || addSelfie2)]
    : []; //listingImages(currentListing, 'facebook');
  const twitterImages = (typeof uploadVideoInPhotoes == 'string' || typeof addSelfie1 == 'string' || typeof addSelfie2 == 'string')
    ? [uploadVideoInPhotoes
      ? uploadVideoInPhotoes.replace(/\.(mp4|mkv|wmv|m4v|mov|avi|flv|webm|flac|mka|m4a|aac|ogg)$/i, '.png')
      : (addSelfie1 || addSelfie2)]
    : []; //listingImages(currentListing, 'twitter');
  const schemaImages = (typeof uploadVideoInPhotoes == 'string' || typeof addSelfie1 == 'string' || typeof addSelfie2 == 'string')
    ? [uploadVideoInPhotoes
      ? uploadVideoInPhotoes.replace(/\.(mp4|mkv|wmv|m4v|mov|avi|flv|webm|flac|mka|m4a|aac|ogg)$/i, '.png')
      : (addSelfie1 || addSelfie2)]
    : [];
  // listingImages(
  //   currentListing,
  //   `${config.layout.listingImage.variantPrefix}-2x`
  // ).map(img => img.url);
  const marketplaceName = config.marketplaceName;
  const schemaTitle = intl.formatMessage(
    { id: 'ListingPage.schemaTitle' },
    { title: isCompany ? companyName : title, price: formattedPrice, marketplaceName }
  );
  // You could add reviews, sku, etc. into page schema
  // Read more about product schema
  // https://developers.google.com/search/docs/advanced/structured-data/product
  const productURL = `${config.marketplaceRootURL}${location.pathname}${location.search}${location.hash}`;
  const schemaPriceMaybe = price
    ? {
      price: intl.formatNumber(convertMoneyToNumber(price), {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      priceCurrency: price.currency,
    }
    : {};
  const currentStock = currentListing.currentStock?.attributes?.quantity || 0;
  const schemaAvailability =
    currentStock > 0 ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock';

  // const createFilterOptions = options => options.map(o => ({ key: `${o.option}`, label: o.label }));
  const hideFractionalMedia = !isOwnListing && (!isAuthenticated || !showPortfolio);

  const printDocument = () => {
    onCreateResumePDF({
      listingId: rawParams.id,
      userName: currentUser.attributes.profile.firstName + ' ' + currentUser.attributes.profile.lastName,
      showPortfolio: !hideFractionalMedia
    }).then(res => window.open(res.cloudinaryUrl, '_blank'));
  }

  const chatGPTQuestions = (listing, onComplete) => {
    const { publicData, title } = (listing && listing.id && listing.attributes) || {};
    const { highestExperience, roles = [], chatGptQuestions
    } = publicData || {};
    const { specialtiesArray = [], favouriteToolArray = [] } = (roles && roles.length && roles[0]) || {};
    setDownloadLoader(true)
    const { url, highestExperience: savedHighestExperience, title: savedTitle, favouriteToolArray: savedfavouriteToolArray, specialtiesArray: savedSpecialtiesArray } = chatGptQuestions || {};
    if ((title == savedTitle) && (highestExperience?.label == savedHighestExperience?.label) && (JSON.stringify(favouriteToolArray) == JSON.stringify(savedfavouriteToolArray)) && (JSON.stringify(specialtiesArray) == JSON.stringify(savedSpecialtiesArray)) && url) {
      setDownloadLoader(false)
      return window.open(url, '_blank');
    }

    if (title && highestExperience && roles) {
      chatGptQuestionsQuery({ roles, highestExperience, title })
        .then(async completion => {
          const content = completion?.data?.choices?.[0]?.message?.content;
          if (content) {
            const blob = downloadAsPDFChatgpt(content, 'Interview_Questions.pdf', title);
            const publicId = `questions_${title?.toString().replace(/\s+/g, '_') || 'role'}`;
            if (blob) {
              const cloudinaryUrl = await uploadPDFToCloudinary(blob, publicId);
              if (cloudinaryUrl) {
                updateRoleQuestion({ cloudinaryUrl, listingId: listing?.id, title, highestExperience, specialtiesArray, favouriteToolArray })
              }
              setDownloadLoader(false)
              onComplete?.();
            }
          }
        })
        .catch(e => {
          setDownloadLoader(false)
          onComplete?.();
          console.error('OpenAI error:', e);
          return e;
        });
    }
    return false;
  };

  const handleSubmitModal = async (values) => {
    const {
      showModal,
      type,
      thoughts = '',
      email = '',
      experienceToken = null,
      ...rest
    } = values;
    if (showModal == "Notes") {
      setModalInProgress(type);
      if (type == 'SEND') {
        // SendGrid Email to particular user
        onInsertCollection({
          to: {
            email,
            name: ''
          },
          thoughts,
          profileUrl: process.env.REACT_APP_MARKETPLACE_ROOT_URL + ('/l/' + listingSlug + '/' + listingId.uuid),
          listingId: listingId.uuid,
          createdAt: moment().toDate(),
          ...rest
        }, type).then(() => {
          setShowModal(false);
          setCopyText('Email_Sent');
          setModalInProgress(false);
        });
      } else {
        const newNote = {
          tableName: 'notes',
          payload: {
            listingId: listingId.uuid,
            userId: currentUser.id.uuid,
            thoughts,
            createdAt: moment().toDate(),
            isActive: '1',
            ...rest
          }
        };

        const existingNote = savedNotes?.find(
          n => n.listingId === listingId?.uuid &&
            n.userId === currentUser?.id?.uuid &&
            n.isActive === '1'
        );

        if (existingNote) {
          Object.assign(newNote, { id: existingNote._id });
          return onInsertCollection(newNote, 'UPDATE').then(() => {
            setShowModal(false);
            setCopyText('Updated_Notes');
            setModalInProgress(false);
          });
        }

        return onInsertCollection(newNote, 'INSERT').then(() => {
          setShowModal(false);
          setCopyText('Saved_Notes');
          setModalInProgress(false);
        });
      }
    } else {
      setModalInProgress('SUBMIT');
      const listingId = new UUID(params.id);
      // onInsertCollection({
      //   tableName: 'connections',
      //   payload: {
      //     listingId: listingId.uuid,
      //     userId: currentUser.id.uuid,
      //     authorId: ensuredAuthor.id.uuid,
      //     createdAt: moment().toDate(),
      //     isActive: '1',
      //     ...rest
      //   }
      // }).then(() => {
      //   mixpanel.track('Connection', {
      //     user_id: currentUser.id.uuid,
      //     recipientEmail: ensuredAuthor.attributes.email,
      //     requesterEmail: currentUser.attributes.email,
      //     hiringRole: rest.role,
      //     companyName: currentUser.attributes.profile.publicData.companyName,
      //     environment: process.env.REACT_APP_ENV,
      //   });

      const roleIndex = publishedListing.findIndex(pl => pl.id.uuid == rest.role);
      const orderParams = {};

      // C-Level -15, Director -10 or Manager/ Specialist -5 tokens are added back to their balance
      if (roleIndex > -1) {
        const hasSufficientTokens = await onCheckPendingDeduction(tokensToDeduct);

        // Find the matching experience of the fractional pro
        const selectedCompanyListing = publishedListing[roleIndex];
        const companyRoles = selectedCompanyListing?.attributes?.publicData?.roles || [];
        const companyRoleLabels = companyRoles.map(r => r?.label).filter(Boolean);

        const matchingExperience = experiences?.find(exp => {
          const expLabel = exp?.label;
          if (!expLabel) return false;
          return companyRoleLabels.some(companyRoleLabel => {
            if (companyRoleLabel.toLowerCase() === expLabel?.toLowerCase()) return true;
            const companyGroup = findRoleGroup(companyRoleLabel);
            const studentGroup = findRoleGroup(expLabel);
            return companyGroup && studentGroup && companyGroup === studentGroup;
          });
        });

        const fractionalPriceVal = matchingExperience?.inputValues?.price;
        const fractionalPrice = fractionalPriceVal
          ? { amount: fractionalPriceVal, currency: config.currency }
          : price
          ? { amount: price?.amount, currency: price?.currency }
          : { amount: 0, currency: config.currency };

        const initialValues = {
          protectedData: {
            listingId: publishedListing[roleIndex].id.uuid,
            hiringRole: rest.role,
            hiringMessage: rest.bio,
            bookingType: 'CONNECTION',
            hoursPerWeek: rest.hoursPerWeek,
            hourlyPrice: fractionalPrice,
            type: "DEBIT",
            RNT_TOKEN_ID: 'connection',
            tokens: tokensToDeduct,
            ...params?.transactionId && { inquiryTransactionId: params?.transactionId }
          },
          confirmPaymentError: null,
        };

        if (!hasSufficientTokens) {
          setInsufficientTokens(true);
          setModalInProgress(false);
          return null
        }

        setInsufficientTokens(false);

        Object.assign(orderParams, {
          listingId,
          quantity: 1,
          needToUpdateWallet: true,
          type: "DEBIT",
          // firstConnectionRequest,
          RNT_TOKEN_ID: 'connection',
          tokens: tokensToDeduct,
          ...initialValues,
        });
      }
      const processAlias = config.listing.listingTypes[0].transactionType.process;
      const process = getProcess(processAlias);

      // Step 1: initiate order by requesting payment from Marketplace API
      const fnRequestPayment = fnParams => {
        // fnParams should be { listingId, deliveryMethod, quantity?, bookingDates?, paymentMethod?.setupPaymentMethodForSaving?, protectedData }
        const requestTransition = process.transitions.REQUEST_PAYMENT;
        const isPrivileged = process.isPrivileged(requestTransition);

        // If paymentIntent exists, order has been initiated previously.
        return onInitiateOrder(fnParams, (processAlias + '/release-1'), null, requestTransition, isPrivileged);
      };

      // Step 2: complete order by confirming payment to Marketplace API
      // Parameter should contain { paymentIntent, transactionId } returned in step 2
      const fnConfirmPayment = fnParams => {
        const order = ensureTransaction(fnParams);
        const transitionName = process.transitions.CONFIRM_PAYMENT;
        return onConfirmPayment({
          ...fnParams,
          transactionId: order.id,
          ...orderParams,
        }, transitionName, {});
      };

      // Step 3: send initial message
      const fnSendMessage = fnParams => {
        return onSendMessage({ ...fnParams, message: rest.bio });
      };


      // Here we create promise calls in sequence
      // This is pretty much the same as:
      const applyAsync = (acc, val) => acc.then(val);
      const composeAsync = (...funcs) => x => funcs.reduce(applyAsync, Promise.resolve(x));
      const handlePaymentIntentCreation = composeAsync(
        fnRequestPayment,
        fnConfirmPayment,
        fnSendMessage,
      );

      // C-Level -15, Director -10 or Manager/ Specialist -5 tokens are added back to their balance
      if (roleIndex > -1 && ((CurrentSeeds >= tokensToDeduct) || !firstConnectionRequest)) {
        return handlePaymentIntentCreation(orderParams)
          .then((res) => {
            mixpanel.track('SeedSpend', {
              distinct_id: currentUser.id.uuid,
              user_id: currentUser.id.uuid,
              email: currentUser.attributes.email,
              ...rest,
              tokens: tokensToDeduct,
              environment: (process.env && process.env.REACT_APP_ENV) || 'development',
            });

          const eventName = roleFromInquiry
            ? 'response_connection_submitted'
            : 'direct_connection_submitted';
          mixpanel.track(eventName, {
            user_id: currentUser?.id?.uuid,
            session_id: getSessionId(),
            candidate_id: ensuredAuthor?.id?.uuid,
            company_name:
              currentUser?.attributes?.profile?.publicData?.companyName ||
              companyName ||
              null,
            hiring_role: rest.role,
            tokens: tokensToDeduct,
            hours_per_week: rest.hoursPerWeek,
            inquiry_transaction_id: params?.transactionId || null,
          });

            setShowModal(false);
            setModalInProgress(false);
            const {
              publicData: userPublicData
            } = (currentListing && currentListing.attributes) || {};
            const { pipedriveDealId, skillsInOne, addExtraExperience, accountType, experiences, roles, addSelfie1 } = userPublicData || {};
            const { pipedriveUserId } = (currentUser && currentUser.attributes && currentUser.attributes.profile && currentUser.attributes.profile.publicData)
            const modifiedExperience = [];
            let dealMoney = 0;
            (experiences && experiences.length && Array.isArray(experiences)) ? experiences.map((data, i) => {
              if (data && data.label && data.inputValues && data.inputValues.price) {
                if (i == 0) {
                  dealMoney = data.inputValues.price;
                }
                modifiedExperience.push({ experienceRole: data.label, earnedMoney: (data.inputValues.price) })
              }
            }) : null;

            (roles && roles.length && Array.isArray(roles) ? roles.map((data, i) => {
              if (data && data.label && data.perHourRate) {
                if (i == 0) {
                  dealMoney = (data.perHourRate.value) / 100;
                }
                modifiedExperience.push({
                  experience: (data && data.experience) ? data.experience : [],
                  perHourRate: (data.perHourRate) / 100,
                  availableHoursPerWeek: (data && data.availableHoursPerWeek) ? data.availableHoursPerWeek : null
                })
              }
            }) : null)
            const filteredItems = (currentUserListings && currentUserListings.length) ? currentUserListings.filter(item => item?.id?.uuid == rest?.role) : null;
            const title = (filteredItems && filteredItems.length) ? filteredItems[0]?.attributes?.title : null;
            if (pipedriveUserId) {
              const dealData = {
                customerId: currentUser?.id?.uuid,
                email,
                listingId: listingId?.uuid,
                accountType: 'company',
                title,
                modifiedExperience,
                dealMoney,
                pipedriveUserId,
                // pipedriveDealId,
                addSelfie1,
                pipeline_id: config.companyRequestPipeline,
                stage_id: config.companyRequestSubmitted,
                roleUserID: rest?.role
              }
              // createDealApi(dealData).then((resp) => {
              //   const { id: pipedriveDealId } = (resp && resp.data && resp.data.data) || {};
              //   if (pipedriveDealId) {
              //     const updateData = {
              //       pipedriveDealId,
              //       id: res?.orderId?.uuid
              //     }
              //     updateTransaction(updateData);
              //   }
              // })
            }
            return history.push(
              createResourceLocatorString(
                'OrderDetailsPage',
                routeConfiguration,
                {
                  id: res.orderId.uuid, // 'InboxPage'
                },
                {}
              ));
          });
      }
      setShowModal(false);
      setFirstConnectionModal('UNSUFFICIENT');
    }
  }

  const handleCompleteProfile = () => {
    if (currentUserListings?.length === 0) {
      history.push(createResourceLocatorString('NewListingPage', routeConfiguration, {}, {}))
    }
    else if (currentUserListings?.length > 0 && currentUserListings?.[0]?.attributes?.state != LISTING_STATE_PUBLISHED) {
      history.push(createResourceLocatorString('EditListingPage', routeConfiguration, {
        id: currentUserListings?.[0]?.id?.uuid,
        slug: currentUserListings?.[0]?.attributes?.publicData?.addExtraExperience?.[0]?.key || "no-slug",
        type: LISTING_STATE_DRAFT,
        tab: 'details'
      }, {}))
    }
  }

  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      author={authorDisplayName}
      description={isCompany
        ? ("Find " + companyName + " on Forteh - Hiring a Fractional Professional for " + (authorListings && authorListings.length ? authorListings[0].attributes.title : '') + " for " + (authorListings && authorListings.length ? '$' + (authorListings[0].attributes.price.amount / 100) : '') + ".")
        : description}
      // facebookImages={isCompany ? [{
      //   height: 630,
      //   name: "facebook",
      //   url: facebookImageURL,
      //   width: 1200
      // }] : facebookImages}
      // twitterImages={isCompany ? [{
      //   height: 314,
      //   name: "twitter",
      //   url: twitterImageURL,
      //   width: 600
      // }] : twitterImages}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'Product',
        description: description,
        name: schemaTitle,
        image: schemaImages,
        offers: {
          '@type': 'Offer',
          url: productURL,
          ...schemaPriceMaybe,
          availability: schemaAvailability,
        },
      }}
    >
      <LayoutSingleColumn className={css.pageRoot} topbar={topbar} footer={<FooterContainer />}>
         <div ref={containerRef}>
        {currentListing.id ? (
          <ActionBarMaybe
            className={css.actionBarForProductLayout}
            isOwnListing={isOwnListing}
            listing={currentListing}
            isCompany={isCompany}
            editParams={{
              id: listingId.uuid,
              slug: listingSlug,
              type: listingPathParamType,
              tab: listingTab,
            }}
            closeListing={onCloseListing}
            openListing={onOpenListing}
          />
        ) : null}
        {isCompany
          ? <SectionCompany
            title={title}
            authorDisplayName={authorDisplayName}
            sendInquiryError={sendInquiryError}
            sendInquiryInProgress={sendInquiryInProgress}
            onSubmitInquiry={onSubmitInquiry}
            listing={currentListing}
            intl={intl}
            config={config}
            listingId={listingId}
            listingSlug={listingSlug}
            listingConfig={listingConfig}
            reviews={reviews}
            history={history}
            share={share}
            listView={listView}
            richTitle={richTitle}
            currentTab={currentTab}
            currentUser={currentUser}
            onUpdateProfile={onUpdateProfile}
            currentListing={currentListing}
            setCurrentTab={setCurrentTab}
            setShowModal={setShowModal}
            filterTabs={filterTabs}
            isOwnListing={isOwnListing}
            fetchReviewsError={fetchReviewsError}
            isAuthenticated={isAuthenticated}
            authorListings={authorListings}
            currentUserListings={currentUserListings}
            onManageDisableScrolling={onManageDisableScrolling}
            onSendMessage={onSendMessage}
            chatGPTQuestions={chatGPTQuestions}
            downloadLoader={downloadLoader}
            onFollowCompany={onFollowCompany}
            onUpdateFollower={onUpdateFollower}
            followCompany={followCompany}
            followCompanyInProgress={followCompanyInProgress}
            onCancelSendgridSearchEmail={onCancelSendgridSearchEmail}
            setProfileModal={setProfileModal}
          />
          : <SectionPro
            intl={intl}
            config={config}
            isAuthenticated={isAuthenticated}
            listingConfig={listingConfig}
            reviews={reviews}
            history={history}
            share={share}
            listView={listView}
            richTitle={richTitle}
            currentTab={currentTab}
            currentUser={currentUser}
            currentListing={currentListing}
            setCurrentTab={setCurrentTab}
            setShowModal={setShowModal}
            filterTabs={filterTabs}
            currentUserListings={currentUserListings}
            onManageDisableScrolling={onManageDisableScrolling}
            showPortfolio={showPortfolio}
            isOwnListing={isOwnListing}
            tokensToDeduct={tokensToDeduct}
            setTokensToDeduct={setTokensToDeduct}
            isClosed={isClosed}
            roleListingFromMongo={roleListingFromMongo}
            parentJobRolesInProgress={parentJobRolesInProgress}
          />}
      </div>

        {/* {['Email_Sent', 'Saved_Notes'].includes(copyText)
          ? <div className={classNames(css.textCopiedPopup, copyText ? css.popUpEntrada : css.popUpSaids)} onClick={() => setCopyText(false)} >
            <svg width="20" height="22" viewBox="0 0 20 22" fill="none" >
              <ellipse cx="10" cy="11" rx="10" ry="10.5" fill="#A9E7B7" />
              <path d="M15.1583 7.63492L8.01225 14.3049L5.85325 12.1469C5.65825 11.9519 5.34125 11.9519 5.14625 12.1469C4.95125 12.3419 4.95125 12.6589 5.14625 12.8539L7.64625 15.3539C7.74325 15.4509 7.87125 15.4999 7.99925 15.4999C8.12225 15.4999 8.24425 15.4559 8.34025 15.3659L15.8403 8.36592C16.0423 8.17792 16.0523 7.86092 15.8643 7.65892C15.6763 7.45692 15.3613 7.44592 15.1583 7.63492Z" stroke="#00A524" />
            </svg>
            <p>
              {['Saved_Notes'].includes(copyText)
                ? <FormattedMessage id={"ListingPageComponent.savedNotesLink"} />
                : <FormattedMessage id={"ListingPageComponent.emailSentLink"} />}
            </p>
            <span className={css.close}>
              <IconShare type='copy' />
            </span>
          </div>
          : null} */}

        <Modal
          id="ListingPage.MultiPurposeModal"
          isOpen={!!showModal}
          onClose={() => setShowModal(false)}
          usePortal
          type={'MultiPurposeModal'}
          onManageDisableScrolling={onManageDisableScrolling}
        >
          {showModal == 'Request'
            ? null
            : <div className={css.logoImage}>
              {uploadVideoInPhotoes
                ? <div className={classNames(css.videoBox, company && !showPortfolio ? css.disableOverlay : null)} >
                  <video width="170" height="170" controls muted  >
                    <source alt={"video"} src={uploadVideoInPhotoes} type="video/mp4" />
                  </video></div> : <ResponsiveImage
                  className={classNames(css.avtarLogo, cAccountType === "company" && !showPortfolio ? css.disableOverlay : null)}
                  alt='display image'
                  url={uploadVideoInPhotoes
                    ? (uploadVideoInPhotoes.replace(/\.(mp4|mkv|wmv|m4v|mov|avi|flv|webm|flac|mka|m4a|aac|ogg)$/i, '.png'))
                    : addSelfie1}
                  showModal
                  image={currentListing.images[0]}
                  variants={['default']}
                />
              }
              <div className={uploadVideoInPhotoes ? css.videoIcon : css.NoVideoIcon}>
                {/* onClick={() => setVideoPlay(true)} */}
                <svg fill="#000000" width="40px" height="40px" viewBox="0 -0.4 26.4 26.4" xmlns="http://www.w3.org/2000/svg"><title>video</title><path d="M13.2 22.8q-2.65 0 -5 -1.35 -2.3 -1.35 -3.65 -3.65T3.2 12.8t1.35 -5 3.65 -3.65 5 -1.35 5 1.35 3.65 3.65 1.35 5q0 2.65 -1.35 5 -1.35 2.3 -3.65 3.65t-5 1.35m4.05 -10 -6.45 -4.8v9.6z" /></svg>
              </div>
            </div>}

          {showModal == 'Share'
            ? <div>
              <SocialShare
                isPlain
                url={getPageURL()}
                createResumeInProgress={createResumeInProgress}
                printDocument={printDocument}
                PageName={'ListingPage'}
                onClose={() => { }}
                isAuthenticated={isAuthenticated}
                onManageDisableScrolling={onManageDisableScrolling}
              />
            </div>
            : <div className={css.chat}>
              <ChatForm
                intl={intl}
                name={title}
                config={config}
                showModal={showModal}
                inProgress={modalInProgress}
                onSubmit={handleSubmitModal}
                currentUserListings={publishedListing}
                showPortfolio={showPortfolio}
                portfolioId={portfolioId}
                insufficientTokens={insufficientTokens}
                tokensToDeduct={tokensToDeduct}
                roleFromInquiry={roleFromInquiry}
                initialValues={{ role: roleFromInquiry ? roleFromInquiry : null }}
                firstConnectionRequest={firstConnectionRequest}
                firstConnectionOnAfterDisable={firstConnectionOnAfterDisable}
                studentListingExperience={experiences}
                history={history}
                listingMinimumPriceSubUnits={config?.listingMinimumPriceSubUnits}
                marketplaceCurrency={config?.currency}
              />
            </div>}
        </Modal>
        <Modal
          id="ListingPage.FirstConnectionModal"
          isOpen={!!firstConnectionModal}
          onClose={() => setFirstConnectionModal(false)}
          usePortal
          onManageDisableScrolling={onManageDisableScrolling}
          className={css.firstConnectionPopup}
        >
          {firstConnectionModal == 'CONNECTION'
            ? <h4 className={css.popupContent}>
              <IconCard brand="IconConnection" />
              <FormattedMessage id={"ListingPage.modalFirstConnectionText"} />
            </h4>
            : <div>
              <h4 className={css.popupContent}>
                <FormattedMessage id={"ListingPage.unsufficientTokenMsg"} />
              </h4>
              <Button
                onClick={() => history.push(createResourceLocatorString('PurchaseAcornsPage', routeConfiguration, {}), {
                  from: `${location.pathname}${location.search}${location.hash}`
                })}
              >
                <FormattedMessage id={"ListingPage.unsufficientTokenButtonMsg"} />
              </Button>
            </div>}
        </Modal>

        {/* Fractionals who do not publish their profiles cannot express interest in roles */}

        <Modal
          id="ListingPage.profileModal"
          isOpen={!!profileModal}
          onClose={() => setProfileModal(false)}
          usePortal
          onManageDisableScrolling={onManageDisableScrolling}
          className={css.showInterestModal}
        >
          To express interest in a role on Forteh, you’ll need to complete your profile first.
          This helps companies better understand your background and ensures meaningful matches.
          <br /><br />
          <Button
            onClick={handleCompleteProfile}
          > Complete your profile </Button>
        </Modal>

        {/* fractional express interest modal  */}
        <Modal
          id="ListingPage.FractionalInterest"
          isOpen={!!showInterestModal}
          onClose={() => setShowInterestModal(false)}
          usePortal
          onManageDisableScrolling={onManageDisableScrolling}
          className={css.showInterestModal}
        >
          You cannot express interest in a role out of your scope of expertise. Please try again for a role related to your experience
        </Modal>

        {isAdminAccount ? null : <Modal
          id="ListingPage.listing"
          isOpen={ListingModal}
          onClose={() => setListingModal(false)}
          usePortal
          onManageDisableScrolling={onManageDisableScrolling}
          className={css.jobmodalDetails}
        >
          <div className={css.jobModalContent}>
            <h3 className={css.modalTitle}>{currentListing?.attributes?.title}
            </h3>
            <p className={css.companyName}>{companyName}</p>
            <ul>
              <li className={css.jobFactsContainer}>
                <span className={css.jobFactList} >{modalWorkType == 'flexible' ? "Flexible to anything" : modalWorkType?.charAt(0)?.toUpperCase() + modalWorkType?.slice(1)} | {modalWorkType !== "remote" && `${modelAddress} |`}  {moment()?.tz(modalWorkType === "remote" ? location?.timezone : modalTimezone)?.format('z')}</span>

                <span className={css.jobFactList} >{modalRoles?.[0]?.availableHoursPerWeek?.label} {modalRoles && modalRoles?.length > 0 && modalRoles?.[0]?.rateType == 'perMonth'? 'Monthly' : 'Weekly'}</span>
                
                {modalRoles && modalRoles?.length > 0 && modalRoles?.[0]?.openHiring && modalRoles?.[0]?.openHiring == 'yes' && <span className={css.jobFactList} >Open to fractional salaried position</span>}
                {modalRoles && modalRoles?.length > 0 && modalRoles[0]?.bonus && modalRoles[0]?.bonus == 'yes' && <span className={css.jobFactList} >Potential for Bonuses</span>}
              </li>
            </ul>

            <h5 className={css.modalSectionTitle}>The Role</h5>
            <p className={css.jobDescription}>{currentListing?.attributes?.description}</p>
            {modalRoles && Array.isArray(modalRoles) && modalRoles?.map((role, index) => (
              <div key={index}>
                {[
                  { title: 'Skills', data: role?.skills },
                  {
                    title: 'Specialties', data: (role && role.
                      specialties && role.
                        specialties.length) ? role?.
                      specialties : (role && role.specialtiesArray && role.specialtiesArray.length
                      ) ? role.specialtiesArray : []
                  },
                  {
                    title: 'Tech Tools', data: (role && role.favouriteTool && role.favouriteTool.length) ? role?.favouriteTool : (role && role.favouriteToolArray && role.favouriteToolArray.length
                    ) ? role.favouriteToolArray : []
                  },
                ].map(({ title, data }, sectionIndex) =>
                  Array.isArray(data) && data.length > 0 ? (
                    <div key={sectionIndex}>
                      <h5 className={css.modalSectionTitle}>{title}</h5>
                      <ul className={css.companiesList}>
                        {data.map((item, itemIndex) => (
                          <li key={itemIndex}>
                            <span>{(item && item.label) ? item?.label : item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : null
                )}
              </div>
            ))}
            <br />
            {isOwnListing ?
              <PrimaryButton
                type="button"
                className={css.secondaryBtn}
                onClick={(e) => {
                  e.preventDefault();
                  chatGPTQuestions(currentListing, () => {
                    setListingModal(false);
                  });
                }}
                inProgress={downloadLoader}
                disabled={downloadLoader}
              >
                Interview Questions
              </PrimaryButton> : null}

            {isOwnListing ? <Button
              className={css.buttonInterested}><NamedLink name="AlgoliaSearchPage" className={css.buttonInterested}>
                Discover Talent

              </NamedLink></Button> : <Button
                className={css.buttonInterested}
                onClick={() => { handleClick(currentListing?.id, userListingId) }}
                disabled={sendInquiryInProgress}
                inProgress={sendInquiryInProgress}
              >
              Show interest
            </Button>

            }
            {isOwnListing ? <Button
              className={css.buttonInterested}>  <NamedLink
                      className={css.buttonInterested}
                      name="MatchedListingsPage"
                      params={{ id: listingId?.uuid }}
                    >
                View Matched Listings
              </NamedLink></Button>
              : null
            }
          </div>
        </Modal>}
      </LayoutSingleColumn>
    </Page >
  );
};

ListingPageComponent.defaultProps = {
  currentUser: null,
  inquiryModalOpenForListingId: null,
  showListingError: null,
  reviews: [],
  fetchReviewsError: null,
  monthlyTimeSlots: null,
  sendInquiryError: null,
  listingConfig: null,
  lineItems: null,
  fetchLineItemsError: null,
};

ListingPageComponent.propTypes = {
  // from useHistory
  history: shape({
    push: func.isRequired,
  }).isRequired,
  // from useLocation
  location: shape({
    search: string,
  }).isRequired,

  // from useIntl
  intl: intlShape.isRequired,

  // from useConfiguration
  config: object.isRequired,
  // from useRouteConfiguration
  routeConfiguration: arrayOf(propTypes.route).isRequired,

  params: shape({
    id: string.isRequired,
    slug: string,
    variant: oneOf([LISTING_PAGE_DRAFT_VARIANT, LISTING_PAGE_PENDING_APPROVAL_VARIANT]),
  }).isRequired,

  isAuthenticated: bool.isRequired,
  currentUser: propTypes.currentUser,
  getListing: func.isRequired,
  getOwnListing: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  scrollingDisabled: bool.isRequired,
  inquiryModalOpenForListingId: string,
  showListingError: propTypes.error,
  callSetInitialValues: func.isRequired,
  reviews: arrayOf(propTypes.review),
  fetchReviewsError: propTypes.error,
  monthlyTimeSlots: object,
  // monthlyTimeSlots could be something like:
  // monthlyTimeSlots: {
  //   '2019-11': {
  //     timeSlots: [],
  //     fetchTimeSlotsInProgress: false,
  //     fetchTimeSlotsError: null,
  //   }
  // }
  sendInquiryInProgress: bool.isRequired,
  sendInquiryError: propTypes.error,
  onSendInquiry: func.isRequired,
  onInitializeCardPaymentData: func.isRequired,
  listingConfig: object,
  onFetchTransactionLineItems: func.isRequired,
  lineItems: array,
  fetchLineItemsInProgress: bool.isRequired,
  fetchLineItemsError: propTypes.error,
};

const EnhancedListingPage = props => {
  const config = useConfiguration();
  const routeConfiguration = useRouteConfiguration();
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();

  return (
    <ListingPageComponent
      config={config}
      routeConfiguration={routeConfiguration}
      intl={intl}
      history={history}
      location={location}
      {...props}
    />
  );
};

const mapStateToProps = state => {
  const { isAuthenticated } = state.auth;
  const {
    authorListingIds,
    showListingError,
    reviews,
    fetchReviewsError,
    monthlyTimeSlots,
    sendInquiryInProgress,
    sendInquiryError,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    inquiryModalOpenForListingId,
    createResumeInProgress,
    showPortfolio,
    portfolioId
  } = state.ListingPage;

  const { savedNotes } = state.SavedNotesPage;

  const { parentJobRolesInProgress, parentJobRoles } = state.EditListingPage;

  const { currentUser, currentUserListings } = state.user;

  const { followCompany, followCompanyInProgress } = state.FollowCompanyPage;


  const getListing = id => {
    const ref = { id, type: 'listing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  const getOwnListing = id => {
    const ref = { id, type: 'ownListing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  const authorListings = getListingsById(state, authorListingIds);

  return {
    isAuthenticated,
    currentUser,
    authorListings,
    currentUserListings,
    getListing,
    getOwnListing,
    scrollingDisabled: isScrollingDisabled(state),
    inquiryModalOpenForListingId,
    showListingError,
    reviews,
    fetchReviewsError,
    monthlyTimeSlots,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    sendInquiryInProgress,
    sendInquiryError,
    createResumeInProgress,
    showPortfolio,
    portfolioId,
    followCompany,
    followCompanyInProgress,
    parentJobRolesInProgress,
    parentJobRoles,
    savedNotes
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  callSetInitialValues: (setInitialValues, values, saveToSessionStorage) =>
    dispatch(setInitialValues(values, saveToSessionStorage)),
  onFetchTransactionLineItems: params => dispatch(fetchTransactionLineItems(params)),
  onSendInquiry: (listing, message) => dispatch(sendInquiry(listing, message)),
  onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),
  onFetchTimeSlots: (listingId, start, end, timeZone) =>
    dispatch(fetchTimeSlots(listingId, start, end, timeZone)),
  onCreateResumePDF: (payload) => dispatch(createResumePDF(payload)),
  onInsertCollection: (payload, type) => dispatch(requestInsertCollection(payload, type)),
  onUpdateProfile: (payload) => dispatch(updateProfile(payload)),
  onSendInquiry: (listing, message, userListingId) => dispatch(sendInquiry(listing, message, userListingId)),
  onInitiateOrder: (params, processAlias, transactionId, transitionName, isPrivileged) =>
    dispatch(initiateOrder(params, processAlias, transactionId, transitionName, isPrivileged)),
  onConfirmPayment: (orderParams, transitionName, transitionParams) =>
    dispatch(confirmPayment(orderParams, transitionName, transitionParams)),
  onCheckPendingDeduction: (payload) => dispatch(checkPendingDeduction(payload)),
  onSendMessage: (txId, message, config) => dispatch(sendMessage(txId, message, config)),
  onCloseListing: (listingId, isCompany) => dispatch(closeListing(listingId, false, isCompany)),
  onOpenListing: (listingId, isCompany) => dispatch(openListing(listingId, false, isCompany)),
  updateRoleQuestion: (data) => dispatch(updateRole(data)),
  onFollowCompany: (data) => dispatch(FollowCompany(data)),
  onUpdateFollower: (followerId) => dispatch(updateFollower(followerId)),

  onCancelSendgridSearchEmail: (userId) => dispatch(onCancelSendgridSearchEmail(userId))
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const ListingPage = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(EnhancedListingPage);

export default ListingPage;